import React from "react";
import NoOffers from "../../../../../../assets/images/noofferfound.gif";
import { t } from "../../../../../utils/i18n";

const NoHits = () => {
  return (
    <div className="no-offer-found">
      <img className="w-50" src={NoOffers} alt={t("p2p.offers.no_offers_alt")} />
      <p>{t("p2p.offers.no_offers")}</p>
    </div>
  );
};

export default NoHits;
